import { ClearRounded } from '@mui/icons-material'
import { CircularProgress, IconButton } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import React from 'react'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { useSelector } from 'react-redux'
import { useEvent } from '@emerald-works/react-event-bus-client'

const DeleteSession = ({ className, loadingClassName, session }) => {
  const confirm = useConfirm()
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)

  const [deleteSession] = useEvent([SkillBiteEditSlice.eventBus.deleteSession])

  const handleDeleteSession = (evt) => {
    evt.preventDefault()
    evt.stopPropagation()
    confirm({
      title: 'Delete session',
      description: 'This is a destructive action. Are you sure you want to delete this session?',
      confirmationText: 'Yes, delete it.',
      confirmationButtonProps: {
        id: 'delete-session-confirmation-button',
        'data-test': 'delete-session-confirmation-button'
      },
      cancellationText: 'No, thanks.',
      cancellationButtonProps: {
        id: 'delete-session-cancellation-button',
        'data-test': 'delete-session-cancellation-button'
      },
      dialogProps: {
        PaperProps: {
          id: 'delete-session-confirmation-modal',
          'data-test': 'delete-session-confirmation-modal'
        }
      },
      titleProps: {
        id: 'delete-session-confirmation-title',
        'data-test': 'delete-session-confirmation-title'
      }
    }).then(() => {
      deleteSession.trigger({ skillBiteId: skillBite.id, sessionId: session.id })
    }).catch(err => {
      console.log('Delete session cancelled', err)
    })
  }

  let icon = <ClearRounded fontSize='small' color='error' />

  if (deleteSession.isWorking) {
    icon = <CircularProgress size='1em' />
  }

  return (
    <IconButton
      size='small'
      onClick={handleDeleteSession}
      disabled={deleteSession.isWorking}
      className={deleteSession.isWorking ? loadingClassName : className}
    >
      {icon}
    </IconButton>
  )
}

export default DeleteSession
